import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function SupportButton() {
  const { user } = useAuth();
  const location = useLocation();

  // Only render if user is authenticated and has a complete profile, and not on /support, /admin or /login pages
  const hasIncompleteProfile = user && (!user.name || !user.email || !user.mobile || !user.dob);
  if (!user || hasIncompleteProfile || location.pathname === '/support' || location.pathname === '/admin' || location.pathname === '/login') return null;

  const targetRoute = user.role === 'admin' ? '/admin/support' : '/support';

  return (
    <Link
      to={targetRoute}
      className="fixed bottom-40 md:bottom-24 right-4 md:right-6 z-30 group flex items-center gap-3 cursor-pointer"
      aria-label="Help Desk Support"
    >
      {/* Tooltip */}
      <span className="hidden md:block bg-white text-gray-800 text-xs font-bold px-3 py-2 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-all transform translate-x-4 group-hover:translate-x-0 pointer-events-none"
        style={{ border: '1px solid var(--card-border)' }}>
        Help & Support
      </span>
      
      {/* Support Icon */}
      <div className="relative mobile-fab-safe w-12 h-12 md:w-14 md:h-14 rounded-xl md:rounded-2xl flex items-center justify-center transition-colors"
        style={{ 
          background: 'var(--primary)',
          boxShadow: '0 10px 22px rgba(79, 70, 229, 0.18)'
        }}>
        <LifeBuoy size={22} color="white" className="z-10" />
      </div>
    </Link>
  );
}
